import React, { useContext, useState, useEffect, useRef } from "react";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import PhoneInputModule from "react-phone-input-2";
const PhoneInput = PhoneInputModule.default || PhoneInputModule;
import "react-phone-input-2/lib/style.css";
import { Form, Dropdown } from "react-bootstrap";
import Row from "react-bootstrap/esm/Row";
import Col from "react-bootstrap/esm/Col";
import Modal from "react-bootstrap/Modal";
import { NavLink, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import InputGroup from "react-bootstrap/InputGroup";
import Spinner from "react-bootstrap/Spinner";
import { Ucontext } from "../context/Ucontext";
import Loading from "../components/loader/Loading";
import { FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import {
  addLandlord,
  adminLogin,
  updateBulkUserInfo,
  updateUserInfo,
  getAllAgencies,
  editLandlord,
  togglerSelfServingStatus,
  togglerInsuranceStatus,
  togglerAffidavitStatus,
  togglerCapacityReportStatus,
  togglerSkorProtectServiceStatus,
  togglerPrescoringAgentFieldsStatus,
  getLandlordWorkspaces,
  addWorkspaceCredit,
} from "../context/functions/AdminFunction";
import { REACT_APP_URL } from "../config";
import { toast } from "react-toastify";
import moment from "moment";
import { IoIosRefresh } from "react-icons/io";
import { getEmailDomain, haveValue } from "../utils/common";
import Pagination from "../components/Pagination";
import { constants } from "../utils/constants";
import GroupedActionMenu from "../components/GroupedActionMenu";
import {
  ChartNoAxesColumn,
  Coins,
  FileText,
  KeyRound,
  ListChecks,
  LogIn,
  Pencil,
  Shield,
} from "lucide-react";
import "../styles/landlord.css";
import InsurancePricingModal from "../components/InsurancePricingModal";
import SkipStepsModal from "../components/SkipStepsModal";
import TenantRequirementsModal from "../components/TenantRequirementsModal";
import { countActiveTenantRequirements } from "../utils/tenantRequirements";

const landlordSettingOptions = [
  {
    field: "self_serving",
    label: "Self serving",
    update: togglerSelfServingStatus,
  },
  {
    field: "insurance_service_status",
    label: "Insurance",
    update: togglerInsuranceStatus,
  },
  {
    field: "capacity_report",
    label: "Capacity report",
    update: togglerCapacityReportStatus,
  },
  {
    field: "skor_protect_service",
    label: "Skor Protect service",
    update: togglerSkorProtectServiceStatus,
  },
  {
    field: "prescoring_agent_fields_enabled",
    label: "Prescoring agent",
    update: togglerPrescoringAgentFieldsStatus,
  },
];

const Landlord = () => {
  const {
    adminDispatch,
    adminState,
    getAllLandlords,
    getAllProperties,
    authState,
    getLandlordProperties,
  } = useContext(Ucontext);
  const { user: adminUser } = authState;
  const defaultLandlord = {
    fname_companyName: "",
    lname: "",
    phone: "",
    email: "",
    lang: "en-us",
    account_status: "approved",
    send_welcome_email: false,
  };

  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(window.location.search);

  const { totalLandlords, totalProperties } = adminState;

  const [sortColumn, setSortColumn] = useState(null);
  const [sortType, setSortType] = useState("");
  const [EditShow, setEditShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [searchVal, setSearchVal] = useState("");
  const [landlordList, setLandlordList] = useState([]);
  const [currentPage, setcurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showCompanyModal, setShowCompanyModal] = useState(false);
  const [companyStatusLandlord, setCompanyStatusLandlord] = useState({});
  const [otpLandlord, setOtpLandlord] = useState({});
  const [showOtp, setShowOtp] = useState(false);
  const [showAddLandlord, setShowAddLandlord] = useState(false);
  const [showEditLandlord, setShowEditLandlord] = useState(false);
  const [agencyDetails, setAgencyDetails] = useState([]);
  const [addLandlordDetails, setAddLandlordDetails] = useState(defaultLandlord);
  const abortControllerRef = useRef(null);

  const [showAddCredit, setShowAddCredit] = useState(false);
  const [addCreditLandlord, setAddCreditLandlord] = useState({});
  const [workspaceOptions, setWorkspaceOptions] = useState([]);
  const [workspaceLoading, setWorkspaceLoading] = useState(false);
  const [creditFormData, setCreditFormData] = useState({
    workspace_id: "",
    amount: "",
  });
  const [addCreditLoading, setAddCreditLoading] = useState(false);
  const [showInsurancePricing, setShowInsurancePricing] = useState(false);
  const [insurancePricingLandlord, setInsurancePricingLandlord] = useState({});
  const [showSkipSteps, setShowSkipSteps] = useState(false);
  const [skipStepsLandlord, setSkipStepsLandlord] = useState({});
  const [tenantRequirementsLandlord, setTenantRequirementsLandlord] =
    useState(null);
  const [pendingSetting, setPendingSetting] = useState(null);
  const [savingSetting, setSavingSetting] = useState(false);

  const showOtpModal = (tenant) => {
    setOtpLandlord(tenant);
    setShowOtp(true);
  };

  const showAddCreditModal = (landlord) => {
    setAddCreditLandlord(landlord);
    setCreditFormData({ workspace_id: "", amount: "" });
    setWorkspaceOptions([]);
    setShowAddCredit(true);
    setWorkspaceLoading(true);
    getLandlordWorkspaces(landlord?._id)
      .then((res) => {
        if (res?.status === "canceled") return;
        setWorkspaceOptions(res?.success_res?.workspaces || []);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error while fetching workspaces");
      })
      .finally(() => {
        setWorkspaceLoading(false);
      });
  };

  const handleCreditAmountChange = (e) => {
    const value = e.target.value;
    if (value !== "" && Number(value) < 0) return;
    setCreditFormData((prev) => ({ ...prev, amount: value }));
  };

  const isValidCreditForm =
    haveValue(creditFormData.workspace_id) &&
    haveValue(creditFormData.amount) &&
    !isNaN(creditFormData.amount) &&
    Number(creditFormData.amount) > 0;

  const handleAddCredit = async () => {
    if (!isValidCreditForm) {
      toast.error("Please select a workspace and enter a valid amount");
      return;
    }
    setAddCreditLoading(true);
    await addWorkspaceCredit(
      creditFormData.workspace_id,
      Number(creditFormData.amount),
    )
      .then((res) => {
        toast.success("Workspace credit updated");
        setShowAddCredit(false);
        setAddCreditLandlord({});
        setCreditFormData({ workspace_id: "", amount: "" });
        setWorkspaceOptions([]);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error while adding credit");
      })
      .finally(() => {
        setAddCreditLoading(false);
      });
  };

  // const [sortBy, setSortBy] = useState('Latest')
  const [filter, setFilter] = useState({
    role: "",
    agency: "",
    isLandlordInComp: "",
  });

  useEffect(() => {
    const controller = new AbortController();
    abortControllerRef.current = controller;

    loadLandlordsAndProperties(
      currentPage,
      searchVal,
      sortColumn,
      filter,
      sortType,
      controller.signal,
    );

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [currentPage, searchVal, sortColumn, filter, sortType]);
  useEffect(() => {
    if (haveValue(queryParameters.get("email"))) {
      setSearchVal(queryParameters.get("email"));
      navigate("/landlord");
    }
    if (haveValue(queryParameters.get("name"))) {
      setSearchVal(queryParameters.get("name"));
      navigate("/landlord");
    }

    getAllAgencies()
      .then((res) => {
        const data = res.data.success_res;
        setAgencyDetails(data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const loadLandlordsAndProperties = async (
    currentPage,
    searchVal,
    sortColumn,
    filter,
    sortType,
    signal = null,
  ) => {
    setLoading(true);
    const { role = "", isLandlordInComp = "", agency = "" } = filter;

    let landlords = await getAllLandlords(
      currentPage,
      searchVal,
      sortColumn,
      role,
      isLandlordInComp,
      sortType,
      agency,
      signal,
    );

    if (landlords?.status === "canceled") {
      return;
    }

    console.log("landlords", landlords);
    if (landlords.status == "Success") {
      adminDispatch({
        type: "LANDLORDS_LOADED",
        payload: landlords?.landlords,
      });
      setLandlordList(landlords?.landlords);
      setTotalPages(landlords?.totalPages);
    }
    // let properties = await getAllProperties();
    // if (properties.status == "success") {
    //   adminDispatch({
    //     type: "PROPERTIES_LOADED",
    //     payload: properties?.properties,
    //   });
    // }
    setLoading(false);
  };

  let interval;
  const handleSearch = (e) => {
    clearTimeout(interval);
    interval = setTimeout(() => {
      setSearchVal(e.target.value);
      setcurrentPage(1);
    }, 500);
  };

  useEffect(() => {
    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, []);

  const handlePageChange = (newPage) => {
    if (newPage > 0) {
      setcurrentPage(newPage);
    }
  };

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setcurrentPage(event.selected + 1);
  };

  const handleClickFilter = (e) => {
    setFilter((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    setcurrentPage(1);
  };

  const handleSorting = (name) => {
    if (
      ![
        "fname_companyName",
        "iban_num",
        "cif_dni_nie",
        "property_count",
        "createdAt",
      ].includes(name)
    ) {
      return;
    }

    if (name == sortColumn) {
      if (sortType == "asc") {
        setSortType("desc");
      } else {
        setSortType("");
        setSortColumn(null);
      }
    } else {
      setSortType("asc");
      setSortColumn(name);
    }
    console.log(name);
    setcurrentPage(1);
  };

  const renderSortIcon = (column) => {
    if (sortColumn !== column) {
      return (
        <FaSort className="sort-icon sort-icon-default" aria-hidden="true" />
      );
    }

    return sortType === "asc" ? (
      <FaSortUp className="sort-icon sort-icon-active" aria-hidden="true" />
    ) : (
      <FaSortDown className="sort-icon sort-icon-active" aria-hidden="true" />
    );
  };

  const handleLogin = (user_id) => {
    const data = {
      user_id,
      user_type: "landlord",
    };
    adminLogin(data)
      .then((res) => {
        console.log(res, "CHECK THIS HERE");
        const queryParams = new URLSearchParams({
          token: res.token || "", // Append token
          usertype: "landlord" || "", // Append usertype
          is_verified: res.user.is_verified || true, // Append is_verified
          saveduserid: res.user._id || "", // Append saveduserid
          external_customer_id: res.user._id || "", // Append external_customer_id
          app_type: "skor" || "", // // Append app_type
        });
        window.open(
          new URL(`${REACT_APP_URL}/redirect?${queryParams.toString()}`).href,
          "_blank",
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const changeLandlordApproval = (landlord) => {
    var data = {
      is_approved: landlord?.is_approved == false ? true : false,
    };
    updateUserInfo(data, landlord?._id, "landlord")
      .then((res) => {
        toast.success("Status Updated");
        loadLandlordsAndProperties(
          currentPage,
          searchVal,
          sortColumn,
          filter,
          sortType,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  // Toggle select all rows
  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(totalLandlords.map((item) => item._id));
    }
    setSelectAll(!selectAll);
  };

  // Toggle selection of a specific row
  const handleRowSelect = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((rowId) => rowId !== id)
        : [...prevSelected, id],
    );
  };

  // Handle status update from dropdown
  const handleStatusUpdate = (status) => {
    if (selectedRows.length === 0) {
      alert("Please select at least one row to update.");
      return;
    }
    var data = { account_status: status };
    updateBulkUserInfo(data, selectedRows, "landlord")
      .then((res) => {
        setSelectedRows([]);
        setSelectAll(false);
        toast.success("Status Updated");
        loadLandlordsAndProperties(
          currentPage,
          searchVal,
          sortColumn,
          filter,
          sortType,
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const openChangeCompanyStatus = (landlord) => {
    setShowCompanyModal(true);
    setCompanyStatusLandlord(landlord);
  };

  const handleChangeCompanyStatus = () => {
    var data = {
      isLandlordInComp:
        haveValue(companyStatusLandlord?.isLandlordInComp) &&
        companyStatusLandlord?.isLandlordInComp != "individual"
          ? "individual"
          : "company",
    };
    // updateUserInfo(data, companyStatusLandlord?._id, "landlord")
    //   .then((res) => {
    //     setShowCompanyModal(false);
    //     if (res.user?.isLandlordInComp == "individual") {
    //       loadLandlordsAndProperties(
    //         currentPage,
    //         searchVal,
    //         sortColumn,
    //         filter,
    //         sortType
    //       );
    //     } else {
    navigate(`/landlorddetail/${companyStatusLandlord?._id}?editCompany=true`);
    //   }
    //   console.log(res, "check the response for updatedlandlord");
    // })
    // .catch((err) => {
    //   console.log(err);
    // });
  };

  function ChangeCompanyStatusModal(props) {
    return (
      <Modal {...props} size="md" centered>
        <Modal.Header closeButton className="landlord-modal-header">
          <Modal.Title className="fw-bold h5">
            Change Company Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="landlord-modal-body">
          <div className="bg-light p-4 rounded-3 border">
            <p className="mb-0 fw-500">
              Are you sure you want to change the status to{" "}
              {haveValue(companyStatusLandlord?.agency?.[0]) &&
              haveValue(companyStatusLandlord?.agency?.[0]?._id)
                ? "No"
                : "Yes. Some additional data will be required"}
              ?
            </p>
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => setShowCompanyModal(false)}
            className="landlord-action-btn"
          >
            Cancel
          </Button>
          <Button
            className="landlord-btn-apply"
            onClick={handleChangeCompanyStatus}
          >
            Update
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  const handleLanguageChange = (e) => {
    setAddLandlordDetails((prev) => ({ ...prev, lang: e.target.value }));
  };
  const handleAddLandlordChange = (e) => {
    setAddLandlordDetails((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmitLandlord = async () => {
    if (
      !haveValue(addLandlordDetails.fname_companyName) ||
      !haveValue(addLandlordDetails.lname) ||
      !haveValue(addLandlordDetails.phone) ||
      !haveValue(addLandlordDetails.email)
    ) {
      toast.error("All Fields are necessary!");
      return;
    }
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        addLandlordDetails.email,
      )
    ) {
      console.log("Valid Email");
    } else {
      toast.error("Invalid Email Address");
      return;
    }
    if (addLandlordDetails.phone.length < 5) {
      toast.error("Please enter full phone number");
      return;
    }
    await addLandlord(addLandlordDetails)
      .then((res) => {
        toast.success("Landlord Created!");
        setShowAddLandlord(false);
        loadLandlordsAndProperties(
          currentPage,
          searchVal,
          sortColumn,
          filter,
          sortType,
        );
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error while creating Landlord");
      });
  };

  const handleSubmitUpdateLandlord = async () => {
    if (
      !haveValue(addLandlordDetails.fname_companyName) ||
      !haveValue(addLandlordDetails.lname) ||
      !haveValue(addLandlordDetails.phone) ||
      !haveValue(addLandlordDetails.email)
    ) {
      toast.error("All Fields are necessary!");
      return;
    }
    if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(
        addLandlordDetails.email,
      )
    ) {
      console.log("Valid Email");
    } else {
      toast.error("Invalid Email Address");
      return;
    }
    if (addLandlordDetails.phone.length < 5) {
      toast.error("Please enter full phone number");
      return;
    }
    await editLandlord(addLandlordDetails)
      .then((res) => {
        toast.success("Landlord Updated!");
        setShowEditLandlord(false);
        loadLandlordsAndProperties(
          currentPage,
          searchVal,
          sortColumn,
          filter,
          sortType,
        );
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error while updating Landlord");
      });
  };

  const handleToggleSelfServing = async (landlordIds) => {
    togglerSelfServingStatus(landlordIds)
      .then((res) => {
        toast.success("Successfully toggled self serving");
        loadLandlordsAndProperties(
          currentPage,
          searchVal,
          sortColumn,
          filter,
          sortType,
        );
      })
      .catch((err) => {
        toast.error("Failed to toggle self serving");
        console.log(err);
      });
  };

  const handleConfirmLandlordSetting = async () => {
    if (!pendingSetting || savingSetting) return;

    const { landlord, setting, nextValue } = pendingSetting;
    setSavingSetting(true);
    try {
      const response = await setting.update([
        { id: landlord?._id, status: nextValue },
      ]);
      const responseStatus = String(response?.status || "").toLowerCase();
      if (
        !response ||
        response?.success === false ||
        response?.status === false ||
        ["error", "fail", "failed", "failure"].includes(responseStatus) ||
        response?.isAxiosError
      ) {
        throw new Error("Landlord setting update failed");
      }

      adminDispatch({
        type: "LANDLORD_SETTING_UPDATED",
        payload: {
          id: landlord._id,
          field: setting.field,
          value: nextValue,
        },
      });
      setPendingSetting(null);
    } catch {
      toast.error(`Could not update ${setting.label}. Try again.`);
    } finally {
      setSavingSetting(false);
    }
  };

  const landlordActionGroups = (landlord) => {
    const isSuperAdmin = adminUser?.role === constants.SUPER_ADMIN;
    const activeTenantRequirements = countActiveTenantRequirements(
      landlord?.tenant_requirements,
    );

    return [
      {
        label: "Access",
        actions: [
          ...(isSuperAdmin
            ? [
                {
                  label: "Login as landlord",
                  icon: <LogIn />,
                  onSelect: () => handleLogin(landlord?._id),
                },
              ]
            : []),
          {
            label: "Show OTP",
            icon: <KeyRound />,
            onSelect: () => showOtpModal(landlord),
          },
        ],
      },
      {
        label: "Account",
        actions: [
          {
            label: "Details",
            icon: <FileText />,
            onSelect: () => navigate(`/landlorddetail/${landlord?._id}`),
          },
          ...(isSuperAdmin
            ? [
                {
                  label: "Edit landlord",
                  icon: <Pencil />,
                  onSelect: () => {
                    setAddLandlordDetails({
                      fname_companyName: landlord?.fname_companyName,
                      lname: landlord?.lname,
                      phone: landlord?.phone,
                      email: landlord?.email,
                      lang: landlord?.lang,
                      landlord_id: landlord?._id,
                      send_welcome_email: false,
                    });
                    setShowEditLandlord(true);
                  },
                },
              ]
            : []),
          {
            label: "View metrics",
            icon: <ChartNoAxesColumn />,
            onSelect: () =>
              navigate(`/landlord-metrics?landlordId=${landlord?._id}`),
          },
          {
            label: "Tenant requirements",
            icon: <ListChecks />,
            badge: `${activeTenantRequirements} active`,
            highlighted: activeTenantRequirements > 0,
            onSelect: () => setTenantRequirementsLandlord(landlord),
          },
        ],
      },
      {
        label: "Billing",
        actions: [
          {
            label: "Add credits",
            icon: <Coins />,
            onSelect: () => showAddCreditModal(landlord),
          },
          {
            label: "Edit insurance pricing",
            icon: <Shield />,
            onSelect: () => {
              setInsurancePricingLandlord(landlord);
              setShowInsurancePricing(true);
            },
          },
        ],
      },
      {
        label: "Tenant flow",
        actions: [
          {
            label: "Manage skip steps",
            icon: <ListChecks />,
            onSelect: () => {
              setSkipStepsLandlord(landlord);
              setShowSkipSteps(true);
            },
          },
        ],
      },
    ];
  };

  const renderLandlordSwitch = (landlord, setting) => {
    const currentValue = landlord?.[setting.field];
    const enabled =
      currentValue === true || currentValue === "true" || currentValue === 1;
    const isSavingThisSetting =
      savingSetting &&
      pendingSetting?.landlord?._id === landlord?._id &&
      pendingSetting?.setting?.field === setting.field;

    return (
      <div className="landlord-setting-control">
        <button
          type="button"
          role="switch"
          aria-checked={enabled}
          aria-label={`${setting.label}: ${enabled ? "On" : "Off"} for ${landlord?.fname_companyName || "landlord"}`}
          className={`landlord-setting-switch${enabled ? " is-on" : ""}`}
          disabled={isSavingThisSetting}
          onClick={() =>
            setPendingSetting({
              landlord,
              setting,
              nextValue: !enabled,
            })
          }
        >
          <span className="landlord-setting-switch-thumb" />
        </button>
        <span className={`landlord-setting-label${enabled ? " is-on" : ""}`}>
          {enabled ? "On" : "Off"}
        </span>
      </div>
    );
  };

  return (
    <>
      <div
        className="landlord-container"
        style={{
          position: "relative",
        }}
      >
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div>
            <h4
              className="fw-800 mb-1"
              style={{
                color: "var(--landlord-color-text-primary)",
                fontSize: "22px",
              }}
            >
              Landlord / Agents
            </h4>
            <p className="text-muted small fw-medium mb-0">
              Manage and view all landlord information
            </p>
          </div>
          <Button
            className="landlord-btn-add"
            onClick={(e) => setShowAddLandlord(true)}
          >
            + Add Landlord / Agent
          </Button>
        </div>

        {loading ? (
          <div
            style={{
              margin: "auto",
            }}
          >
            <Loading />
          </div>
        ) : null}

        {/* Filters Card */}
        <Card className="landlord-card shadow-sm mb-4">
          <Card.Body className="p-3">
            <div className="landlord-filter-row">
              <div className="landlord-filter-item-wide">
                <span className="landlord-filter-label">Search</span>
                <InputGroup size="sm">
                  <InputGroup.Text className="landlord-search-group-text">
                    <FiSearch size={14} />
                  </InputGroup.Text>
                  <Form.Control
                    className="landlord-search-input"
                    placeholder="Search by name, email, or NIF..."
                    defaultValue={
                      haveValue(queryParameters.get("email"))
                        ? queryParameters.get("email")
                        : ""
                    }
                    onChange={handleSearch}
                  />
                </InputGroup>
              </div>

              <div className="landlord-filter-item">
                <span className="landlord-filter-label">Agency</span>
                <Form.Select
                  onChange={handleClickFilter}
                  name="agency"
                  id="agency"
                  size="sm"
                  value={filter.agency}
                  style={{ height: "38px", borderRadius: "6px" }}
                >
                  <option value="">All</option>
                  {agencyDetails.map(
                    (detail) =>
                      haveValue(detail?.company_name) && (
                        <option key={detail?._id} value={detail?._id}>
                          {detail?.company_name}
                        </option>
                      ),
                  )}
                </Form.Select>
              </div>

              <div className="landlord-filter-item">
                <span className="landlord-filter-label">Is Institution</span>
                <Form.Select
                  name="isLandlordInComp"
                  id="isLandlordInComp"
                  onChange={handleClickFilter}
                  size="sm"
                  value={filter.isLandlordInComp}
                  style={{ height: "38px", borderRadius: "6px" }}
                >
                  <option value="">All</option>
                  <option value="yes">Yes</option>
                  <option value="no">No</option>
                </Form.Select>
              </div>

              {selectedRows.length > 0 && (
                <div className="landlord-bulk-actions ms-auto">
                  <Dropdown>
                    <Dropdown.Toggle
                      className="landlord-bulk-dropdown"
                      size="sm"
                    >
                      Update Status ({selectedRows.length})
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() => handleStatusUpdate("pending")}
                      >
                        Pending
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleStatusUpdate("approved")}
                      >
                        Approved
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() => handleStatusUpdate("not-approved")}
                      >
                        Not Approved
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Dropdown>
                    <Dropdown.Toggle
                      className="landlord-bulk-dropdown"
                      size="sm"
                    >
                      Self Serving ({selectedRows.length})
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item
                        onClick={() =>
                          handleToggleSelfServing(
                            selectedRows.map((row) => ({
                              id: row,
                              status: true,
                            })),
                          )
                        }
                      >
                        Enable
                      </Dropdown.Item>
                      <Dropdown.Item
                        onClick={() =>
                          handleToggleSelfServing(
                            selectedRows.map((row) => ({
                              id: row,
                              status: false,
                            })),
                          )
                        }
                      >
                        Disable
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>

        {/* Landlord List Card */}
        {loading ? null : (
          <Card className="landlord-card shadow-sm mb-4">
            <Card.Header className="bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
              <h6
                className="mb-0 fw-800 text-uppercase"
                style={{ fontSize: "13px", letterSpacing: "0.05em" }}
              >
                Landlord List
              </h6>
              <span
                className="text-muted small fw-medium"
                style={{ fontSize: "11px" }}
              >
                {totalLandlords?.length || 0} rows
              </span>
            </Card.Header>
            <div className="table-responsive">
              <Table responsive hover className="landlord-table">
                <thead>
                  <tr>
                    <th className="text-center">
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className="landlord-checkbox"
                      />
                    </th>
                    <th
                      className="sortable-header"
                      onClick={() => handleSorting("fname_companyName")}
                    >
                      <span className="sortable-header-content">
                        NAME {renderSortIcon("fname_companyName")}
                      </span>
                    </th>
                    <th>DOMAIN NAME</th>
                    <th
                      className="sortable-header"
                      onClick={() => handleSorting("iban_num")}
                    >
                      <span className="sortable-header-content">
                        IBAN {renderSortIcon("iban_num")}
                      </span>
                    </th>
                    <th
                      className="sortable-header"
                      onClick={() => handleSorting("cif_dni_nie")}
                    >
                      <span className="sortable-header-content">
                        NIF/DNI/NIE {renderSortIcon("cif_dni_nie")}
                      </span>
                    </th>
                    <th>LANDLORD/AGENT</th>
                    <th>IS INSTITUTION</th>
                    <th
                      className="text-center sortable-header"
                      onClick={() => handleSorting("property_count")}
                    >
                      <span className="sortable-header-content">
                        NO. OF PROPERTIES {renderSortIcon("property_count")}
                      </span>
                    </th>
                    <th>LAST LOGIN</th>
                    <th>SELF SERVING</th>
                    <th>INSURANCE</th>
                    <th>CAPACITY REPORT</th>
                    <th>SKOR PROTECT SERVICE</th>
                    <th>PRESCORING AGENT</th>
                    {/* <th>AFFIDAVIT</th> */}
                    <th
                      className="sortable-header"
                      onClick={() => handleSorting("createdAt")}
                    >
                      <span className="sortable-header-content">
                        CREATED AT {renderSortIcon("createdAt")}
                      </span>
                    </th>
                    <th>ACTIONS</th>
                  </tr>
                </thead>
                <tbody>
                  {totalLandlords &&
                    totalLandlords.map((landlord, index) => (
                      <tr key={landlord?._id}>
                        <td className="text-center">
                          <input
                            type="checkbox"
                            checked={selectedRows.includes(landlord?._id)}
                            onChange={() => handleRowSelect(landlord?._id)}
                            className="landlord-checkbox"
                          />
                        </td>
                        <td>
                          <div className="landlord-name-stack">
                            <span className="landlord-name">
                              {landlord?.fname_companyName} {landlord?.lname}
                            </span>
                            <span className="landlord-email">
                              {landlord?.email || "N/A"}
                            </span>
                          </div>
                        </td>
                        <td className="fw-500">
                          {getEmailDomain(landlord?.email)}
                        </td>
                        <td className="fw-500 text-muted">
                          {landlord?.iban_num || "-"}
                        </td>
                        <td className="fw-500">
                          {landlord?.cif_dni_nie || "-"}
                        </td>
                        <td className="fw-500">
                          {haveValue(landlord?.agency[0]) &&
                            (haveValue(landlord?.agency[0]?.agency_type)
                              ? landlord?.agency[0]?.agency_type
                              : "agent")}
                        </td>
                        <td>
                          {haveValue(landlord?.agency_id) ? (
                            <span className="landlord-kyc-yes">Yes</span>
                          ) : (
                            <span className="landlord-kyc-no">No</span>
                          )}
                        </td>
                        <td className="text-center fw-600">
                          {landlord?.properties?.length || 0}
                        </td>
                        <td className="text-muted small fw-medium">
                          {landlord.lastLoginFrom ?? "Desktop"}
                        </td>
                        <td>
                          {renderLandlordSwitch(
                            landlord,
                            landlordSettingOptions[0],
                          )}
                        </td>
                        <td>
                          {renderLandlordSwitch(
                            landlord,
                            landlordSettingOptions[1],
                          )}
                        </td>
                        <td>
                          {renderLandlordSwitch(
                            landlord,
                            landlordSettingOptions[2],
                          )}
                        </td>
                        <td>
                          {renderLandlordSwitch(
                            landlord,
                            landlordSettingOptions[3],
                          )}
                        </td>
                        <td>
                          {renderLandlordSwitch(
                            landlord,
                            landlordSettingOptions[4],
                          )}
                        </td>
                        <td className="text-muted small fw-medium">
                          {moment(landlord?.createdAt).format("DD MMM YYYY")}
                        </td>
                        <td>
                          <div className="landlord-row-actions">
                            <GroupedActionMenu
                              groups={landlordActionGroups(landlord)}
                              searchable
                              className="landlord-actions-dropdown"
                            />
                            {adminUser?.role === constants.SUPER_ADMIN && (
                              <button
                                type="button"
                                className="landlord-login-icon-btn"
                                title="Login as landlord"
                                aria-label="Login as landlord"
                                onClick={() => handleLogin(landlord?._id)}
                              >
                                <LogIn size={18} aria-hidden="true" />
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  {totalLandlords?.length === 0 && (
                    <tr>
                      <td colSpan={16} className="text-center py-5 text-muted">
                        No Data Found!
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>
            {totalLandlords?.length > 0 && (
              <div className="d-flex justify-content-end p-3 border-top bg-light bg-opacity-50">
                <Pagination
                  currentPage={currentPage - 1}
                  totalPages={totalPages}
                  onPageChange={handlePageClick}
                  pageRangeDisplayed={3}
                  className="pagination landlord-pagination mb-0"
                />
              </div>
            )}
          </Card>
        )}
        {/* <div className="">
          <button
            onClick={() => handlePageChange(+currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>
          <span>{`Page ${currentPage} of ${totalPages}`}</span>
          <button
            onClick={() => handlePageChange(+currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div> */}
      </div>
      {/* OTP Modal */}
      <Modal
        show={showOtp}
        size="md"
        centered
        onHide={() => {
          setShowOtp(false);
          setOtpLandlord({});
        }}
      >
        <Modal.Header closeButton className="landlord-modal-header">
          <Modal.Title className="fw-bold h5">
            OTP for {otpLandlord?.fname || ""} {otpLandlord?.lname || ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="landlord-modal-body">
          <div className="bg-light p-4 rounded-3 border text-center">
            <p
              className="text-muted small mb-2 fw-bold text-uppercase"
              style={{ fontSize: "11px", letterSpacing: "0.05em" }}
            >
              One-Time Password
            </p>
            <h3
              className="fw-bold mb-0"
              style={{ fontSize: "28px", letterSpacing: "8px" }}
            >
              {otpLandlord?.otp || "-----"}
            </h3>
          </div>
        </Modal.Body>
      </Modal>

      {/* Add Landlord Modal */}
      <Modal
        show={showAddLandlord}
        size="lg"
        centered
        onHide={() => {
          setShowAddLandlord(false);
          setAddLandlordDetails(defaultLandlord);
        }}
      >
        <Modal.Header closeButton className="landlord-modal-header">
          <Modal.Title className="fw-bold h5">Add Landlord</Modal.Title>
        </Modal.Header>
        <Modal.Body className="landlord-modal-body">
          <Row className="g-3">
            <Col md={6}>
              <label className="landlord-form-label">First Name</label>
              <Form.Control
                type="text"
                className="landlord-form-control"
                name="fname_companyName"
                onChange={handleAddLandlordChange}
                value={addLandlordDetails?.fname_companyName}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Last Name</label>
              <Form.Control
                type="text"
                className="landlord-form-control"
                name="lname"
                onChange={handleAddLandlordChange}
                value={addLandlordDetails?.lname}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Email</label>
              <Form.Control
                type="email"
                className="landlord-form-control"
                name="email"
                onChange={handleAddLandlordChange}
                value={addLandlordDetails?.email}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Phone Number</label>
              <PhoneInput
                className="phone_input"
                international
                country="es"
                value={addLandlordDetails.phone}
                onChange={(e) =>
                  setAddLandlordDetails((prev) => ({ ...prev, phone: e }))
                }
                containerStyle={{ width: "100%" }}
                inputStyle={{ width: "100%", height: "38px" }}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Language</label>
              <div className="landlord-radio-group">
                <label className="landlord-radio-label">
                  <input
                    type="radio"
                    onChange={handleLanguageChange}
                    checked={
                      addLandlordDetails?.lang === "en-us" ||
                      addLandlordDetails?.lang === "en-US"
                    }
                    name="radio"
                    value="en-us"
                  />
                  <span>EN</span>
                </label>
                <label className="landlord-radio-label">
                  <input
                    type="radio"
                    onChange={handleLanguageChange}
                    checked={addLandlordDetails?.lang === "es"}
                    name="radio"
                    value="es"
                  />
                  <span>ES</span>
                </label>
              </div>
            </Col>
            <Col md={6} className="d-flex align-items-end pb-2">
              <Form.Check
                type="checkbox"
                checked={addLandlordDetails.send_welcome_email}
                onChange={(e) =>
                  setAddLandlordDetails((prev) => ({
                    ...prev,
                    send_welcome_email: e.target.checked,
                  }))
                }
                label="Send Welcome Email"
                className="fw-500"
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setShowAddLandlord(false);
              setAddLandlordDetails(defaultLandlord);
            }}
            className="landlord-action-btn"
          >
            Cancel
          </Button>
          <Button className="landlord-btn-apply" onClick={handleSubmitLandlord}>
            Create
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Edit Landlord Modal */}
      <Modal
        show={showEditLandlord}
        size="lg"
        centered
        onHide={() => {
          setShowEditLandlord(false);
          setAddLandlordDetails(defaultLandlord);
        }}
      >
        <Modal.Header closeButton className="landlord-modal-header">
          <Modal.Title className="fw-bold h5">Edit Landlord</Modal.Title>
        </Modal.Header>
        <Modal.Body className="landlord-modal-body">
          <Row className="g-3">
            <Col md={6}>
              <label className="landlord-form-label">First Name</label>
              <Form.Control
                type="text"
                className="landlord-form-control"
                name="fname_companyName"
                onChange={handleAddLandlordChange}
                value={addLandlordDetails?.fname_companyName}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Last Name</label>
              <Form.Control
                type="text"
                className="landlord-form-control"
                name="lname"
                onChange={handleAddLandlordChange}
                value={addLandlordDetails?.lname}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Email</label>
              <Form.Control
                type="email"
                className="landlord-form-control"
                name="email"
                onChange={handleAddLandlordChange}
                value={addLandlordDetails?.email}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Phone Number</label>
              <PhoneInput
                className="phone_input"
                international
                country="es"
                value={addLandlordDetails.phone}
                onChange={(e) =>
                  setAddLandlordDetails((prev) => ({ ...prev, phone: e }))
                }
                containerStyle={{ width: "100%" }}
                inputStyle={{ width: "100%", height: "38px" }}
              />
            </Col>
            <Col md={6}>
              <label className="landlord-form-label">Language</label>
              <div className="landlord-radio-group">
                <label className="landlord-radio-label">
                  <input
                    type="radio"
                    onChange={handleLanguageChange}
                    checked={
                      addLandlordDetails?.lang === "en-us" ||
                      addLandlordDetails?.lang === "en-US"
                    }
                    name="radio"
                    value="en-us"
                  />
                  <span>EN</span>
                </label>
                <label className="landlord-radio-label">
                  <input
                    type="radio"
                    onChange={handleLanguageChange}
                    checked={addLandlordDetails?.lang === "es"}
                    name="radio"
                    value="es"
                  />
                  <span>ES</span>
                </label>
              </div>
            </Col>
            <Col md={6} className="d-flex align-items-end pb-2">
              <Form.Check
                type="checkbox"
                checked={addLandlordDetails.send_welcome_email}
                onChange={(e) =>
                  setAddLandlordDetails((prev) => ({
                    ...prev,
                    send_welcome_email: e.target.checked,
                  }))
                }
                label="Send Welcome Email"
                className="fw-500"
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setShowEditLandlord(false);
              setAddLandlordDetails(defaultLandlord);
            }}
            className="landlord-action-btn"
          >
            Cancel
          </Button>
          <Button
            className="landlord-btn-apply"
            onClick={handleSubmitUpdateLandlord}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={Boolean(pendingSetting)}
        centered
        dialogClassName="landlord-setting-confirmation-dialog"
        className="landlord-setting-confirmation"
        onHide={() => !savingSetting && setPendingSetting(null)}
        aria-labelledby="landlord-setting-confirm-title"
      >
        <Modal.Header className="landlord-setting-confirmation-header">
          <Modal.Title
            id="landlord-setting-confirm-title"
            className="landlord-setting-confirmation-title"
          >
            Confirm setting change
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="landlord-setting-confirmation-body">
          {pendingSetting && (
            <p className="landlord-setting-confirmation-prompt">
              Turn {pendingSetting.nextValue ? "on" : "off"}{" "}
              {pendingSetting.setting.label} for{" "}
              <strong>
                {`${pendingSetting.landlord?.fname_companyName || ""} ${pendingSetting.landlord?.lname || ""}`.trim()}
              </strong>
              ?
            </p>
          )}
        </Modal.Body>
        <Modal.Footer className="landlord-setting-confirmation-footer">
          <Button
            variant="outline-secondary"
            className="landlord-action-btn"
            disabled={savingSetting}
            onClick={() => setPendingSetting(null)}
          >
            Cancel
          </Button>
          <Button
            className="landlord-btn-apply"
            disabled={savingSetting}
            onClick={handleConfirmLandlordSetting}
          >
            {savingSetting ? (
              <>
                <Spinner size="sm" animation="border" className="me-2" />
                Saving...
              </>
            ) : (
              `Turn ${pendingSetting?.nextValue ? "on" : "off"}`
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Credit Modal */}
      <Modal
        show={showAddCredit}
        size="md"
        centered
        onHide={() => {
          setShowAddCredit(false);
          setAddCreditLandlord({});
          setCreditFormData({ workspace_id: "", amount: "" });
          setWorkspaceOptions([]);
        }}
      >
        <Modal.Header closeButton className="landlord-modal-header">
          <Modal.Title className="fw-bold h5">
            Add Credits{" "}
            {addCreditLandlord?.fname_companyName
              ? `- ${addCreditLandlord.fname_companyName}`
              : ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="landlord-modal-body">
          <Row className="g-3">
            <Col md={12}>
              <label className="landlord-form-label">Workspace</label>
              <Form.Select
                className="landlord-form-control"
                value={creditFormData.workspace_id}
                disabled={workspaceLoading}
                onChange={(e) =>
                  setCreditFormData((prev) => ({
                    ...prev,
                    workspace_id: e.target.value,
                  }))
                }
              >
                <option value="" hidden>
                  {workspaceLoading
                    ? "Loading workspaces..."
                    : "Select workspace"}
                </option>
                {!workspaceLoading &&
                  workspaceOptions.map((ws) => (
                    <option key={ws.id} value={ws.id}>
                      {ws.name}
                    </option>
                  ))}
              </Form.Select>
              {workspaceLoading && (
                <div className="d-flex align-items-center gap-2 mt-2 text-muted small">
                  <Spinner size="sm" animation="border" />
                  Loading workspaces...
                </div>
              )}
            </Col>
            <Col md={12}>
              <label className="landlord-form-label">Amount</label>
              <Form.Control
                type="number"
                min={0}
                className="landlord-form-control"
                name="amount"
                placeholder="Enter amount"
                value={creditFormData.amount}
                onChange={handleCreditAmountChange}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <Button
            variant="outline-secondary"
            onClick={() => {
              setShowAddCredit(false);
              setAddCreditLandlord({});
              setCreditFormData({ workspace_id: "", amount: "" });
              setWorkspaceOptions([]);
            }}
            className="landlord-action-btn"
          >
            Cancel
          </Button>
          <Button
            className="landlord-btn-apply"
            onClick={handleAddCredit}
            disabled={!isValidCreditForm || addCreditLoading}
          >
            {addCreditLoading ? (
              <>
                <Spinner size="sm" animation="border" className="me-2" />
                Adding credits...
              </>
            ) : (
              "Add Credit"
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {showInsurancePricing && (
        <InsurancePricingModal
          show={showInsurancePricing}
          landlord={insurancePricingLandlord}
          onHide={() => {
            setShowInsurancePricing(false);
            setInsurancePricingLandlord({});
          }}
        />
      )}

      {tenantRequirementsLandlord && (
        <TenantRequirementsModal
          show
          landlord={tenantRequirementsLandlord}
          onHide={() => setTenantRequirementsLandlord(null)}
          onSave={(tenantRequirements) =>
            adminDispatch({
              type: "LANDLORD_SETTING_UPDATED",
              payload: {
                id: tenantRequirementsLandlord._id,
                field: "tenant_requirements",
                value: tenantRequirements,
              },
            })
          }
        />
      )}

      {showSkipSteps && (
        <SkipStepsModal
          show={showSkipSteps}
          landlord={skipStepsLandlord}
          onHide={() => {
            setShowSkipSteps(false);
            setSkipStepsLandlord({});
          }}
          onSave={() =>
            loadLandlordsAndProperties(
              currentPage,
              searchVal,
              sortColumn,
              filter,
              sortType,
            )
          }
        />
      )}

      {/* Change Company Status Modal */}
      <ChangeCompanyStatusModal
        show={showCompanyModal}
        onHide={() => setShowCompanyModal(false)}
      />
    </>
  );
};

export default Landlord;
